export enum CollegeSlug {
    CHRYSM = "chrysm",
    NAU = "nau",
    HHS = "hhs",
    Northstar = "northstar",
    Ogleschool = "ogleschool",
    Demo = "demo"
}
